import { setLabels } from "../helpers/enum-helpers";

export interface PieceRateActivity {
    id: number;
    description: string;
    businessUnit: string;
    code: string;
    activityType: ActivityType;
}

export enum ActivityType {
    ChepRepair = 1,
    GmaRepair = 2,
    Other = 3,
    PecoRepair = 4
}
